import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { UserService } from 'src/services/user.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  currentUser: any;
  tokenExpiration!: string;

  constructor(
    private msalService: MsalService,
    private userService: UserService,
    private http: HttpClient
  ) { }


  ngOnInit(): void {
    //this.userService.init();
      this.tokenExpiration = localStorage.getItem('tokenExpiration')!

      this.userService.UserValues.subscribe((data: any) => {
        this.currentUser = data;
      });
  }

  signOut() {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  }
}
